import * as React from 'react';

import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import QuestionnaireFormContainer from '../../containers/QuestionnaireForm';
import i18n from '../../resources/i18n';
/**
 * アセスメント回答画面
 * @param props
 */
const AssessmentForm: React.FC<any> = props => {
	const careerID = props.match.params.career_id;
	const classID = props.match.params.class_id;
	const id = props.match.params.questionnaire_id;
	const type = props.match.params.type;
	const flg = props.location.state.flgcommit;

	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('AssessmentForm_0001')} />
			<QuestionnaireFormContainer
				careerID={careerID}
				classID={classID}
				id={id}
				type={type}
				flg={flg}
				assessmentFlg={true}
				onlyQuestionFlg={false}
			/>
		</>
	);
};

export default AssessmentForm;



// WEBPACK FOOTER //
// ./src/pages/personal/AssessmentForm.tsx